import axios from "axios"

export default async function getCounties(state: string): Promise<string[]> {
    const res = await axios.get(`/api/account/counties/${state}`)
    return res.data
}
